// @flow

import React from "react";
import { Button } from "react-bootstrap";
import "./styles.css";
import econ from "./../images/ECON.svg";
import exec from "./../images/EXEC.svg";
import coac from "./../images/COAC.svg";
import priv from "./../images/PRIV.svg";
import limo from "./../images/LIMO.svg";
import prio from "./../images/PRIO.svg";
import shar from "./../images/SHAR.svg";
import schd from "./../images/SCHD.svg";
import ec1 from "./../images/EC1.svg";
import ec2 from "./../images/EC2.svg";
import ec3 from "./../images/EC3.svg";
import ec4 from "./../images/EC4.svg";
import eclx from "./../images/ECLX.svg";
import ecop from "./../images/ECOP.svg";
import bus from "./../images/BUS.svg";
import shpl from "./../images/SHPL.svg";
import eightlim from "./../images/EIGHTLIM.svg";
import lsuv from "./../images/LSUV.svg";
import dshu from "./../images/DSHU.svg";

type Props = {
  onSelect: Function,
  visibility: string,
  currency: string,
  data: {
    image: Image,
    transferType: string,
    optionCost: Object,
    description: Array<string>,
    book: boolean,
    transferTypeCode: string
  }
};

const TransferOption = ({
  currency,
  onSelect,
  visibility,
  basketId,
  postBasketData,
  idValueOutbound,
  idValueInbound,
  qID,
  data: { book, description, image, optionCost, transferType, transferTypeCode }
}: Props) => {
  const images = {
    econ,
    exec,
    coac,
    priv,
    limo,
    prio,
    shar,
    schd,
    ec1,
    ec2,
    ec3,
    ec4,
    eclx,
    ecop,    
    bus,
    shpl,
    eightlim,
    lsuv,
    dshu
  };
  const localImage = images[transferTypeCode.toLowerCase()];

  const handleClick = () => {
    postBasketData(basketId, idValueOutbound, {
      transferType: { code: transferTypeCode, description: transferType }
    }).then(() => {
      if (idValueInbound) {
        postBasketData(basketId, idValueInbound, {
          transferType: { code: transferTypeCode, description: transferType }
        });
      }
    });
    window.history.replaceState(
      null,
      "Airport Transfers to Ski Resorts | Ski-Lifts",
      "/quote/" + qID + "/stp2/transferDetailsOutboundForm/1"
    );
    onSelect();
  };

  return (
    <div className="infobox">
      <div className="main-section">
        <div className="top-image">
          <img src={localImage} alt="" />
        </div>
<div className="middle-details-wrapper">
        <div className="details-section">
        <div className="circle-text">
            <h3><strong>{transferType}</strong></h3>
            
          </div>
          <h4 dangerouslySetInnerHTML={{ __html: description[0] }} />

        </div>
        <div className="detailsToggle">
        <input type="checkbox" />
<div className="info-btn">

<span></span>
        <span></span>
        <span></span>
</div>

        <ul className="detailsPanel">
          <div className="section">
            <div dangerouslySetInnerHTML={{ __html: description[1] }} />
          </div>          <div className="section">
            <div dangerouslySetInnerHTML={{ __html: description[2] }} />
          </div>
          <div className="section">
            <div dangerouslySetInnerHTML={{ __html: description[3] }} />
          </div>
        </ul>
      </div>
        </div>
        <div className="btn-section">
        <h2>
              <strong>
                {optionCost.pricesFrom
                  ? "Limited Availability"
                  : currency + (optionCost.totalCost / 100).toFixed(2)}
              </strong>
            </h2>
        <h5>
              {optionCost.pricesFrom
                ? "Prices from " +
                  currency +
                  (optionCost.totalCost / 100).toFixed(2)
                : currency +
                  (optionCost.costPerPerson / 100).toFixed(2) +
                  " per person"}
            </h5>
        <Button
          onClick={handleClick}
          bsSize="large"
          className="book-now-button"
          bsStyle={book ? "success" : "warning"}
        >
         <span>{book ? "Book now" : "Enquire"}</span> 
        </Button>
        </div>
      </div>
    </div>
  );
};

export default TransferOption;



// WEBPACK FOOTER //
// ./src/containers/QuotePage/TransferOptionsPanel/TransferOptions/index.js